import { helpChapters } from './content';

type HelpCenterOptions = { onOpen?:()=>void; onClose?:()=>void };

export function setupHelpCenter(options:HelpCenterOptions = {}) {
  const overlay=document.querySelector<HTMLElement>('#helpOverlay')!;
  const nav=document.querySelector<HTMLElement>('#helpNav')!;
  const article=document.querySelector<HTMLElement>('#helpArticle')!;
  let activeId=helpChapters[0].id;
  let previousFocus:HTMLElement|null=null;

  function renderChapter(id:string) {
    const chapter=helpChapters.find((item)=>item.id===id)??helpChapters[0]; activeId=chapter.id;
    nav.querySelectorAll<HTMLButtonElement>('button').forEach((button)=>button.setAttribute('aria-current',String(button.dataset.helpChapter===chapter.id)));
    article.replaceChildren();
    const heading=document.createElement('h2');heading.textContent=chapter.title;
    const lead=document.createElement('p');lead.className='help-lead';lead.textContent=chapter.lead;
    article.append(heading,lead);
    chapter.sections.forEach((section)=>{
      const block=document.createElement('section');const title=document.createElement('h3');title.textContent=section.title;block.append(title);
      section.paragraphs?.forEach((text)=>{const paragraph=document.createElement('p');paragraph.textContent=text;block.append(paragraph);});
      if(section.items){const list=document.createElement('ul');section.items.forEach((text)=>{const item=document.createElement('li');item.textContent=text;list.append(item);});block.append(list);}
      article.append(block);
    });
    article.scrollTop=0;
  }

  helpChapters.forEach((chapter)=>{const button=document.createElement('button');button.type='button';button.dataset.helpChapter=chapter.id;button.textContent=chapter.title;button.addEventListener('click',()=>renderChapter(chapter.id));nav.append(button);});
  renderChapter(activeId);

  function open() { if(!overlay.hidden)return;previousFocus=document.activeElement as HTMLElement|null;options.onOpen?.();overlay.hidden=false;document.body.classList.add('help-open');document.querySelector<HTMLButtonElement>('#helpClose')!.focus(); }
  function close() { if(overlay.hidden)return;overlay.hidden=true;document.body.classList.remove('help-open');options.onClose?.();previousFocus?.focus(); }
  document.querySelector('#helpBtn')!.addEventListener('click',open);
  document.querySelector('#helpClose')!.addEventListener('click',close);
  overlay.addEventListener('pointerdown',(event)=>{if(event.target===overlay)close();});
  window.addEventListener('keydown',(event)=>{if(!overlay.hidden&&event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();close();}},true);
  return { open, close, isOpen:()=>!overlay.hidden };
}
